module.exports = __webpack_public_path__ + "assets/img/icon_sd.857ebcdb.png";